import Http from "@/commons/Http";
import Utils from "@/utils/Utils";

const path = 'api/certificate';

const calculateProgressCertificates = (certificates = []) => {
    if (!Array.isArray(certificates) || certificates.length === 0) {
        return 0;
    }
    let total = 0;
    for (const certificate of certificates) {
        total += calculateProgress(certificate);
    }
    const percentage = total / certificates.length;
    return Number(percentage >= 100 ? percentage : percentage.toFixed(2));
};

const calculateProgress = (certificate) => {
    if(Utils.isEmptyNullOrUndefined(certificate) || Utils.isEmptyNullOrUndefined(certificate.typeOfCertificate)){
        return 0;
    }

    if (certificate.completedManually) {
        return 100;
    }

    if (certificate.typeOfCertificate === 'REFERENCE') {
        return calculateReferenceProgress(certificate);
    } else {
        // Lista de campos obrigatórios para calcular o progresso
        let requiredFields = [
            'typeOfCertificate',
            'typeOfDocument',
            'price'
        ];

        // Campos adicionais dependendo do tipo de certificado
        if (certificate.typeOfCertificate === 'IDENTIFICATION') {
            requiredFields.push('personNameInDocument');
        }

        if (certificate.typeOfCertificate === 'WEDDING' && ['CIVIL', 'RELIGIOUS'].includes(certificate.typeOfDocument)) {
            requiredFields.push('dataCertificate');
        }

        if (certificate.typeOfCertificate === 'ADDRESS_PROOF' && !['ADDRESS_PROOF_OWN', 'ADDRESS_PROOF_ADDRESS'].includes(certificate.typeOfDocument)) {
            requiredFields.push('addressReferenceName');
        }

        if (certificate.typeOfCertificate === 'ADDRESS_PROOF' && ['ADDRESS_PROOF_ADDRESS'].includes(certificate.typeOfDocument)) {
            requiredFields.push('address');
        }

        // translatePrice é obrigatório se statusTranslate for diferente de 'NOT_NECESSARY'
        if (certificate.statusTranslate !== 'NOT_NECESSARY') {
            requiredFields.push('translatePrice');
        }

        // statusDocument é obrigatório e precisa estar no escritório
        if (certificate.statusDocument !== 'OFFICE') {
            requiredFields.push('statusDocument');
        }

        // statusTranslate é obrigatório se statusTranslate for diferente de 'NOT_NECESSARY'
        if (!['NOT_NECESSARY', 'OFFICE'].includes(certificate.statusTranslate)) {
            requiredFields.push('statusTranslate');
        }

        // Conta quantos campos obrigatórios existem
        const totalFields = requiredFields.length;
        let filledFields = 0;

        for (let field of requiredFields) {
            if (field === 'price' || field === 'translatePrice') {
                if (certificate[field] && certificate[field] !== '0,00') {
                    filledFields++;
                }
            } else {
                if (field == 'statusDocument' && certificate.statusDocument === 'OFFICE') {
                    filledFields++;
                } else if (field == 'statusTranslate' && ['NOT_NECESSARY', 'OFFICE'].includes(certificate.statusTranslate)) {
                    filledFields++;
                } else if (!['statusDocument', 'statusTranslate'].includes(field) && !Utils.isEmptyNullOrUndefined(certificate[field])) {
                    filledFields++;
                }
            }
        }

        // Calcula o percentual preenchido
        let percentage = (filledFields / totalFields) * 100;
        return Number(percentage.toFixed(2));
    }
};

const calculateReferenceProgress = (certificate) => {
    if (Utils.isEmptyNullOrUndefined(certificate) || Utils.isEmptyNullOrUndefined(certificate.typeOfCertificate)) {
        return 0;
    }
    // Existem 2 campos obrigatórios: processReferencePerson e typeOfDocument
    // Cada um vale 50% do progresso
    let percentage = 0;
    if (!Utils.isEmptyNullOrUndefined(certificate.processReferencePerson)) {
        percentage += 50;
    }
    if (!Utils.isEmptyNullOrUndefined(certificate.typeOfDocument)) {
        percentage += 50;
    }
    return percentage;
};

const getAllCertificates = (checklist) => {
    let certificates = [];

    const collectCertificates = (checklist) => {
    if (checklist && Array.isArray(checklist.certificates)) {
        certificates = certificates.concat(checklist.certificates);
    }
    if (checklist && Array.isArray(checklist.children)) {
        checklist.children.forEach(child => collectCertificates(child));
    }
    };

    collectCertificates(checklist);
    return certificates;
};

export default {

    async save(certificates){
        return Http.post(`${path}/`, certificates);
    },

    async saveOne(certificate){
        return Http.post(`${path}/save-one`, certificate, { silent: true });
    },

    async delete(certificateId) {
        return Http.delete(`${path}/${certificateId}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "Protocol"};
        return Http.post(`${path}/audit?sort=${sort || 'a.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'p.code'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
    },

    async getByProtocolId(id){
        return Http.get(`${path}/protocol/${id}`);
    },

    calculateProgress: calculateProgress,
    calculateProgressCertificates: calculateProgressCertificates,
    getAllCertificates: getAllCertificates,

}
